import { createContext, useContext, useState } from 'react';
import { App, User } from '../models';
import jwt_decode from 'jwt-decode';
import { defaultUser } from '../models/User';

const AppContext = createContext<App>({
    appLoading: false,
    setAppLoading: () => {},
    iframeLoading: false,
    setIframeLoading: () => {},
    token: '',
    setToken: () => {},
    user: defaultUser,
    logout: () => {},
    headerTitle: null,
    setHeaderTitle: () => {},
    isLogged: () => {},
});

interface Props {
    children: React.ReactNode;
}

export function AppProvider({ children }: Props) {
    const tokenStorage = localStorage.getItem('token');
    const t = tokenStorage && tokenStorage.length > 10 ? tokenStorage : '';
    const [token, setToken] = useState<string>(t);
    const [appLoading, setAppLoading] = useState<boolean>(true);
    const [iframeLoading, setIframeLoading] = useState<boolean>(false);
    const [user, setUser] = useState<User>(t ? jwt_decode<User>(t) : defaultUser);
    const [headerTitle, setHeaderTitle] = useState();

    const PersistToken = async (token: string) => {
        localStorage.setItem('token', token);
        setToken(token);
        localStorage.removeItem('iframeUrl');
        const localStorageUser = token ? jwt_decode<User>(token) : defaultUser;
        setUser(localStorageUser);
        localStorage.setItem('token_mercure', localStorageUser.token_mercure);
    };

    const logout = () => {
        setToken('');
        localStorage.removeItem('token');
        localStorage.removeItem('token_mercure');
    };

    const isLogged = () => {
        return user?.token !== '';
    };

    // Force logout if user want to change is password. Reset is used to avoid logout after form submit
    const pathname = window.location.pathname;
    const searchParams = new URLSearchParams(window.location.search);
    const reset = searchParams.get('reset');
    if ((pathname === '/mdp-new-pass' || pathname === '/finalise-account') && token && !reset) {
        logout();
    }

    return (
        <AppContext.Provider
            value={{
                appLoading,
                setAppLoading,
                iframeLoading,
                setIframeLoading,
                token,
                setToken: PersistToken,
                logout,
                user,
                headerTitle,
                setHeaderTitle,
                isLogged,
            }}
        >
            {children}
        </AppContext.Provider>
    );
}

export const useAppContext = () => useContext(AppContext);
